import { render, staticRenderFns } from "./CreateReview.vue?vue&type=template&id=9329a70c&scoped=true"
import script from "./CreateReview.vue?vue&type=script&lang=js"
export * from "./CreateReview.vue?vue&type=script&lang=js"
import style0 from "./CreateReview.vue?vue&type=style&index=0&id=9329a70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9329a70c",
  null
  
)

export default component.exports